import "./Midas.css";

const Midas = () => {
    return (
        <main className="midas-page">
            <div className="midas-container">
                <h1>MIDAS Production</h1>
                <iframe
                    className="midas-frame"
                    src="https://app.databox.com/datawall/6c956a004e1162ea6ebd43d45ff8b10d06149c309"
                ></iframe>
            </div>
            <div className="midas-container">
                <h1>MIDAS Stage</h1>
                <iframe
                    className="midas-frame"
                    src="https://app.databox.com/datawall/ae285234c8f2046df62b0cbce940db650610d2a59"
                ></iframe>
            </div>
        </main>
    );
};

export default Midas;
